import { type AppDispatch } from "features/Application/globaltypes/redux";
import { setState, setDependencies } from "../slices/accountDependenciesSlice";
import DataService from "features/Application/services/dataServices/typedDataService";

export const fetchAccountDependencies = (accountId: number) => async (dispatch: AppDispatch) => {
  dispatch(setState("loading"));

  const result = await DataService.accounts.getAccountDependencies(accountId);

  dispatch(setDependencies(result));
  dispatch(setState("fetched"));
};
